module.exports = __webpack_public_path__ + "static/img/tel-directory.de58581a.svg";